export const validateFieldValue = (value, message) =>
	value === null || value === '' || value === undefined ? message : null

export const validateFlightNumber = (value, message) =>
	value.length >= 8 ? message : null